// src/components/GoogleSignInButton.js

import React, { useEffect, useRef, useCallback, useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { API } from '../api/config';

const GOOGLE_CLIENT_ID = "959663341026-ocgjmot8b2lm32sah0omqm5js6rj079r.apps.googleusercontent.com";
const API_URL = API.LOGIN;

function GoogleSignInButton() {
    const { login } = useContext(AuthContext);
    const signInButtonRef = useRef(null);
    const [error, setError] = useState("");

    const handleCredentialResponse = useCallback(async (response) => {
        const googleToken = response.credential;
        setError(""); 

        try {
            const apiResponse = await fetch(`${API_URL}/auth/clients/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: googleToken }), 
            });

            const data = await apiResponse.json();

            if (!apiResponse.ok) {
                throw new Error(data.error || "Falha na autenticação");
            }

            login(data);

        } catch (err) {
            console.error("Login Error:", err);
            setError("Não foi possível conectar. Por favor, tente novamente.");
        }
    }, [login]); 

    useEffect(() => {
        // Função isolada para renderizar o botão
        const renderButton = () => {
            if (window.google?.accounts?.id && signInButtonRef.current) {
                window.google.accounts.id.initialize({
                    client_id: GOOGLE_CLIENT_ID,
                    callback: handleCredentialResponse
                });

                window.google.accounts.id.renderButton(
                    signInButtonRef.current,
                     { 
                        theme: "outline", 
                        size: "large", 
                        type: "standard", 
                        text: "continue_with", 
                        shape: "pill", 
                        logo_alignment: "center",
                        width: 220 
                     } 
                );
            }
        };

        // 1. Se o script do Google já carregou (navegação normal), renderiza logo.
        if (window.google?.accounts?.id) {
            renderButton();
        } else {
            // 2. Se não carregou (redirecionamento rápido), vamos rastrear o script!
            let script = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');

            // Prevenção: caso o script não exista no index.html, injetamos ele.
            if (!script) {
                script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            }

            // O pulo do gato: Esperamos o script gritar "Carreguei!" para desenhar o botão.
            script.addEventListener('load', renderButton);

            // Limpeza caso o componente seja desmontado
            return () => {
                script.removeEventListener('load', renderButton);
            };
        }
    }, [handleCredentialResponse]); 

    return (
        <div className="w-full flex flex-col items-center justify-center">
            {/* Onde o botão vai nascer */}
            <div ref={signInButtonRef} className="min-h-[40px] flex justify-center w-8/10"></div>
            
            {/* Soft Error State */}
            {error && (
                <div className="mt-4 bg-[#971253]/10 border border-[#971253]/20 text-[#971253] text-xs font-medium px-4 py-2.5 rounded-lg text-center animate-in fade-in slide-in-from-top-2 w-full max-w-[280px]">
                    {error}
                </div>
            )}
        </div>
    );
}

export default GoogleSignInButton;